import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import GeneratedRecord from "../../models/generated-record";

interface RecordDeleteItemsModalProps {
  show: boolean;
  record?: GeneratedRecord;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const RecordDeleteItemsModal: React.FC<RecordDeleteItemsModalProps> = ({
  show,
  record,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = record
    ? `Está seguro de que quiere los ITEMS de la entrada: #${record.id}`
    : "";

  const onDeleteClick = async () => {
    if (record !== undefined) {
      setSubmitting(true);
      const recordStatus = await deleteItem<GeneratedRecord>(
        `/records/${record.id}/delete_items/`,
        record
      );

      if (recordStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (recordStatus.detail !== undefined) {
          message = recordStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-warning" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar ITEMS</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
              <h3 className="text-danger">Precaución</h3>
              <h5>
                Esta función permite borrar los Items añadidos en caso de error. Esto con el objetivo de volver a cargarlos correctamente
              </h5>
              <h5>
                No se recomienda borrar Items si ya hay documentos impresos con el QR
              </h5>
              <h5>
                Esta acción no se puede deshacer
              </h5>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="warning">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default RecordDeleteItemsModal;
